import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Flex,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightAddon,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import CarouselPublishAdupdate from 'components/adspresso/creativeTrackingForms/CarouselPublishAdupdate';
import CatalogueCarouselPublishAdUpdate from 'components/adspresso/creativeTrackingForms/CatalogueCarouselPublishAdUpdate';
import CatalogueSinglePublishAdUpdate from 'components/adspresso/creativeTrackingForms/CatalogueSinglePublishAdUpdate';
import SinglePublishAdupdate from 'components/adspresso/creativeTrackingForms/SinglePublishAdupdate';
import SizePublishAdupdate from 'components/adspresso/creativeTrackingForms/SizePublishAdupdate';
import AdvantagePlusShoppingSalesForm from 'components/campaignForms/AdSetForms/AdvantageShoppingSalesForm';
import AppPromotionForm from 'components/campaignForms/AdSetForms/AppPromotionForm';
import AwarenessForm from 'components/campaignForms/AdSetForms/AwarenessForm';
import CatalogueSalesForm from 'components/campaignForms/AdSetForms/CatalogueSalesForm';
import EngagementForm from 'components/campaignForms/AdSetForms/EngagementForm';
import LeadsForm from 'components/campaignForms/AdSetForms/LeadsForm';
import SalesForm from 'components/campaignForms/AdSetForms/SalesForm';
import TrafficForm from 'components/campaignForms/AdSetForms/TrafficForm';
import SidebarWithHeader from 'components/SidebarWithHeader';
import currencySymbolMap from 'currency-symbol-map';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FiEdit2 } from 'react-icons/fi';
import { TiArrowBack } from "react-icons/ti";
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { usePublishAdspressoCampaignMutation } from 'store/adspresso/adspressoCampaignApi';
import { useGetBmAdAccountsDetailsQuery } from 'store/BmAccounts/bmAccountApi';
import { useGetAdsetFormQuery } from 'store/campaigns/adsetFormApi';
import { setSelectedAdsetId, setSelectedAdsId, setSelectedCampaignId } from 'store/campaigns/campaignsSlice';
import { useGetPublishStatusQuery, useUpdatePublishCampaignMutation } from 'store/publishTracking/trackingApi';

export const PublishTracking = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const bgColor = useColorModeValue("#f8f6fb", "#1e1530");
    const { isOpen: isBidModalOpen, onOpen: onBidModalOpen, onClose: onBidModalClose } = useDisclosure();
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [selectedTracking, setSelectedTracking] = useState(null);
    const [targetingData, setTargetingData] = useState(null);
    const [editType, setEditType] = useState('');
    const [shouldRefetch, setShouldRefetch] = useState(true);
    const [previousErrors, setPreviousErrors] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);
    const [adsetBidAmounts, setAdsetBidAmounts] = useState({});

    const { data: trackingData, refetch } = useGetPublishStatusQuery({ campaignId: id },
        { pollingInterval: shouldRefetch ? 10000 : null, skipPollingIfUnfocused: true }
    );

    const { data: bmAdAccountsDetails, isLoading: isBmAdAccountsLoading } = useGetBmAdAccountsDetailsQuery(
        {
            adsAccounts: [selectedTracking?.adsAccount?.adsAccountId],
        },
        { skip: !selectedTracking?.adsAccount?.adsAccountId }
    );

    const currencyCode = bmAdAccountsDetails?.data && bmAdAccountsDetails?.data?.[0]?.currency;
    const currencySymbol = currencySymbolMap(currencyCode);

    let campaignType = null;
    let createCampaignTracking;
    let smartPromotionType;
    let productCatalogId;

    if (trackingData) {

        const selectedAccountId = selectedTracking?.adsAccount?.id;
        createCampaignTracking = trackingData?.find(tracking =>
            tracking.action === 'createCampaign' && tracking?.adsAccount?.id === selectedAccountId
        );

        if (createCampaignTracking) {
            campaignType = createCampaignTracking?.form?.objective;
            smartPromotionType = createCampaignTracking?.form?.smart_promotion_type === 'AUTOMATED_SHOPPING_ADS';
            productCatalogId = createCampaignTracking?.form?.promoted_object?.product_catalog_id;
        }
    }

    const [updatePublishCampaign, { isLoading: isCampaignUpdating }] = useUpdatePublishCampaignMutation({});
    const { data: dataSales, error: errorSales, isLoading: isLoadingSales } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_SALES' }, { skip: campaignType !== 'OUTCOME_SALES' });
    const { data: dataCatalogueSales, error: errorCatalogueSales, isLoading: isLoadingCatalogueSales } = useGetAdsetFormQuery(
        {
        campaign_type: 'OUTCOME_SALES',
        promoted_object: { product_catalog_id: productCatalogId }
        },
        { skip: !productCatalogId }
    );
    const { data: dataLeads, error: errorLeads, isLoading: isLoadingLeads } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_LEADS' }, { skip: campaignType !== 'OUTCOME_LEADS' });
    const { data: dataAwareness, error: errorAwareness, isLoading: isLoadingAwareness } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_AWARENESS' }, { skip: campaignType !== 'OUTCOME_AWARENESS' }); 
    const { data: dataTraffic, error: errorTraffic, isLoading: isLoadingTraffic } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_TRAFFIC' }, { skip: campaignType !== 'OUTCOME_TRAFFIC' }); 
    const { data: dataEngagement, error: errorEngagement, isLoading: isLoadingEngagement } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_ENGAGEMENT' }, { skip: campaignType !== 'OUTCOME_ENGAGEMENT' }); 
    const { data: dataAdvantageShopping, isLoading: isLoadingAdvantageShopping } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_SALES', smart_promotion_type: 'AUTOMATED_SHOPPING_ADS' }, { skip: campaignType !== 'OUTCOME_SALES' || !smartPromotionType });
    const { data: dataAppPromotions, error: errorAppPromotions, isLoading: isLoadingAppPromotions } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_APP_PROMOTION' }, { skip: campaignType !== 'OUTCOME_APP_PROMOTION' });
    const [publishAdspressoCampaign, { isSuccess, isError, isLoading: isPublishLoading }] = usePublishAdspressoCampaignMutation();

    useEffect(() => {
        if (trackingData) {
            const allSuccess = trackingData.every(tracking => tracking?.status === 'success');
            const hasError = trackingData.some(tracking => tracking?.status === 'error');
            const hasPending = trackingData.some(tracking => tracking?.status === 'pending');

            if (hasPending) {
                setShouldRefetch(true);
            } else if (hasError || allSuccess) {
                setShouldRefetch(false);
            }
        }
    }, [trackingData]);

    const handleEditClick = (tracking) => {
        setSelectedTracking(tracking);
        setEditType(tracking?.action);
        setIsEditOpen(true);
    };

    const groupedTrackingData = trackingData?.reduce((acc, tracking) => {
        const accountName = tracking?.adsAccount?.adsAccountName;
        if (!acc[accountName]) {
            acc[accountName] = [];
        }
        acc[accountName].push(tracking);
        return acc;
    }, {});

    useEffect(() => {
        if (selectedTracking?.form) {
            campaignFormik.setValues({
                name: selectedTracking?.form?.name,
                objective: selectedTracking?.form?.objective,
                isAdvantageCampaignEnabled: selectedTracking?.form?.bid_strategy ? true : false,
                isAdScheduled: selectedTracking?.form?.pacing_type && selectedTracking?.form?.pacing_type.includes("day_parting") ? true : false,
                budget: selectedTracking?.form?.daily_budget ? 'daily_budget' : 'lifetime_budget',
                bid_strategy: selectedTracking?.form?.bid_strategy ? selectedTracking?.form?.bid_strategy : 'LOWEST_COST_WITHOUT_CAP',
                daily_budget: selectedTracking?.form?.daily_budget ? Number(selectedTracking?.form?.daily_budget) / 100 : 800,
                lifetime_budget: selectedTracking?.form?.lifetime_budget ? Number(selectedTracking?.form?.lifetime_budget) / 100 : 14000,
            });
        }
    }, [selectedTracking?.form]);

    // campaignFormik setup for edit campaign
    const campaignFormik = useFormik({
        initialValues: {
            name: '',
            objective: '',
            isAdvantageCampaignEnabled: false,
            isAdScheduled: false,
            budget: 'daily_budget',
            bid_strategy: 'LOWEST_COST_WITHOUT_CAP',
            daily_budget: 800,
            lifetime_budget: 14000,
        },
        enableReinitialize: true,
        onSubmit: (values) => {

            const { name, budget, daily_budget, lifetime_budget, isAdScheduled, isAdvantageCampaignEnabled, bid_strategy } = values;

            let payload = {
                ...selectedTracking?.form,
                name,
            };

            if (!isAdvantageCampaignEnabled) {
                // CASE 1: Not using Advantage Campaign
                const adset_budgets = [];

                if (Array.isArray(selectedTracking?.form?.adsets)) {
                    selectedTracking?.form.adsets.forEach((adsetId) => {
                        const budgetValue = selectedTracking?.form?.daily_budget || selectedTracking?.form?.lifetime_budget;
                        const isDailyBudget = !!selectedTracking?.form?.daily_budget;

                        if (adsetId && budgetValue) {
                            adset_budgets.push({
                                adset_id: adsetId,
                                [isDailyBudget ? 'daily_budget' : 'lifetime_budget']: Number(budgetValue)
                            });
                        }

                    });
                }

                if (adset_budgets.length > 0) {
                    payload.adset_budgets = adset_budgets;
                }

                if (budget === 'lifetime_budget') {
                    payload.lifetime_budget = Number(lifetime_budget) * 100;
                    payload.currency = currencyCode;
                }

                if (budget === 'daily_budget') {
                    payload.daily_budget = Number(daily_budget) * 100;
                    payload.currency = currencyCode;
                }

                if (bid_strategy && selectedTracking?.form?.bid_strategy) {
                    payload.bid_strategy = bid_strategy;
                }

                if (isAdScheduled) {
                    payload.pacing_type = ["day_parting"];
                }

            } else {
                // CASE 2: Advantage Campaign Flow
                if (budget === 'lifetime_budget') {
                    payload.lifetime_budget = Number(lifetime_budget) * 100;
                    payload.currency = currencyCode;
                }

                if (budget === 'daily_budget') {
                    payload.daily_budget = Number(daily_budget) * 100;
                    payload.currency = currencyCode;
                }


                if (isAdScheduled) {
                    payload.pacing_type = ["day_parting"];
                }

                // Only add bid_strategy & adset_bid_amounts if it changed
                if (bid_strategy && bid_strategy !== selectedTracking?.form?.bid_strategy) {
                    payload.bid_strategy = bid_strategy;

                    // Only set adset_bid_amounts if bid_strategy is NOT "LOWEST_COST_WITHOUT_CAP"
                    if (bid_strategy !== "LOWEST_COST_WITHOUT_CAP") {
                        payload.adset_bid_amounts = {};

                        Object.entries(adsetBidAmounts).forEach(([adSetId, value]) => {
                            payload.adset_bid_amounts[adSetId] = value * 100;
                        });
                    } else {

                        payload.adset_bid_amounts = {};

                        Object.entries(adsetBidAmounts).forEach(([adSetId, value]) => {
                            payload.adset_bid_amounts[adSetId] = null;
                        });
                    }
                }
            }

            updatePublishCampaign({
                trackingId: selectedTracking?._id,
                payload
            }).unwrap()
                .then(() => {
                    refetch();
                    toast({
                        position: "top-right",
                        title: "Campaign updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                    setIsEditOpen(false);
                })
                .catch((error) => {
                    toast({
                        position: "top-right",
                        title: "Error updating campaign",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                    console.error('Error updating campaign:', error);
                });
        },
    });


    const handleBudgetChange = (e) => {
        const selectedBudgetType = e.target.value;
        if (selectedBudgetType === 'daily_budget') {
            campaignFormik.setFieldValue('lifetime_budget', Number(campaignFormik.values.lifetime_budget));
            campaignFormik.setFieldValue('daily_budget', Number(campaignFormik.values.daily_budget));
        } else if (selectedBudgetType === 'lifetime_budget') {
            campaignFormik.setFieldValue('daily_budget', Number(campaignFormik.values.daily_budget));
            campaignFormik.setFieldValue('lifetime_budget', Number(campaignFormik.values.lifetime_budget));
        }
        campaignFormik.setFieldValue('budget', selectedBudgetType);
    };

    const handleSaveSuccess = () => {
        refetch();
    };

    useEffect(() => {
        if (isPublishLoading) {
            setTimeout(() => {
                refetch();
            }, 2000);

            setTimeout(() => {
                refetch();
            }, 3000);

            setTimeout(() => {
                refetch().then(() => {
                    setIsPublishing(false);
                });
            }, 5000);
        }
    }, [isPublishLoading]);

    const handleRePublish = async () => {
        setIsPublishing(true);

        try {
            await publishAdspressoCampaign(id)
                .unwrap()
                .then((response) => {
                    refetch(); // First refresh
                    // Optionally, navigate after the re-publish is complete
                    // setTimeout(() => {
                    //     navigate(`/launchpad/${id}`);
                    //     // navigate(`/campaigns/${id}`);
                    // }, 1000);
                });

        } catch (error) {
            console.error("Error republishing campaign:", error);
            setIsPublishing(false);
        }
    };

    useEffect(() => {
        if (isSuccess) {
            toast({
                position: "top-right",
                title: "Campaign Re-published",
                status: "success",
                duration: 4000,
                isClosable: true,
            });
        }
    }, [isSuccess])

    useEffect(() => {
        if (isError) {
            toast({
                position: "top-right",
                title: "Error Re-publishing campaign",
                status: "error",
                duration: 4000,
                isClosable: true,
            });
        }
    }, [isError])

    const TrackingTable = ({ title, actions, actionType }) => {
        const filteredActions = actions?.filter(tracking => tracking?.action === actionType);

        const getPath = () => {
            switch (actionType) {
                case 'createCampaign':
                    return '/campaigns';
                case 'createAdset':
                    return '/campaigns';
                case 'createAd':
                    return '/campaigns';
                default:
                    return '';
            }
        };

        const getTab = () => {
            switch (actionType) {
                case 'createCampaign':
                    return 0;
                case 'createAdset':
                    return 1;
                case 'createAd':
                    return 2;
                default:
                    return 0;
            }
        };

        const getTrackingId = (tracking) => {
            return tracking[actionType === 'createCampaign' ? 'campaign' :
                actionType === 'createAdset' ? 'adset' :
                    'ad']?.[`${actionType.split('create')[1].toLowerCase()}_id`];
        };

        return (
            <>
                {filteredActions.length > 0 && (
                    <>
                        <Tbody>
                            <Tr >
                                <Td border="none" textAlign="left" p={'5px'}>
                                    <Text fontSize={'14px'} fontWeight='bold'> {title}</Text>
                                </Td>
                                {/* <Text fontSize={'14px'} fontWeight='bold' p={'5px'}> {title}</Text> */}
                            </Tr>
                            {filteredActions.map((tracking) => {
                                const adsAccountId = tracking?.adsAccount?.adsAccountId;
                                const trackingId = getTrackingId(tracking);
                                const path = getPath();
                                const name = encodeURIComponent(tracking?.form?.name);
                                const tab = getTab();

                                return (
                                    <Tr key={tracking?._id} >
                                        <Td fontSize={'14px'} p={'5px'}>{tracking?.form?.name}</Td>
                                        <Td p={'5px'}>
                                            <Link
                                                to={`${path}?adsAccountId=${adsAccountId}&tab=${tab}`}
                                                onClick={() => {
                                                    localStorage.setItem('sourcePublish', 'publish');
                                                    if (actionType === 'createCampaign') {
                                                        dispatch(setSelectedCampaignId(trackingId));
                                                    } else if (actionType === 'createAdset') {
                                                        dispatch(setSelectedAdsetId(trackingId));
                                                    } else {
                                                        dispatch(setSelectedAdsId(trackingId));
                                                    }
                                                }}
                                                style={{ textDecoration: 'underline' }}
                                            >
                                                <Text fontSize='14px' fontWeight='bold'>{trackingId}</Text>
                                            </Link>
                                        </Td>
                                        {tracking?.status === 'error' && !tracking?.updated ? (
                                            <Td textAlign={'center'} p={'5px'}>
                                                <Flex direction="column" alignItems="center">
                                                    <Flex gap={2} alignItems={'center'}>
                                                        <Box role='group' position={"relative"} _hover={{ cursor: "pointer", transition: "all 0.3s ease" }}>
                                                            <Tooltip
                                                                label={
                                                                    <Box fontSize="sm" >
                                                                        <Text fontWeight="bold">{tracking?.error?.error?.error_user_title || tracking?.error?.error_user_title}</Text>
                                                                        <Text>{tracking?.error?.error_user_msg || tracking?.error?.message || tracking?.error?.error?.error_user_msg}</Text>
                                                                    </Box>
                                                                }
                                                                hasArrow
                                                                fontSize='md'>
                                                                <Text color={'red.500'} fontSize={'14px'} fontWeight={'bold'}>
                                                                    {tracking?.status?.charAt(0).toUpperCase() + tracking?.status?.slice(1)}
                                                                </Text>
                                                            </Tooltip>
                                                        </Box>
                                                        <Tooltip label='' fontSize='xs'>
                                                            <Icon
                                                                _hover={{ color: "gray.500" }}
                                                                as={FiEdit2}
                                                                cursor={"pointer"}
                                                                onClick={() => handleEditClick(tracking)}
                                                            />
                                                        </Tooltip>
                                                    </Flex>
                                                </Flex>
                                            </Td>
                                        ) : (
                                            <Td textAlign={'center'} p={'5px'}>
                                                <Box display="inline-flex" alignItems="center" gap={2}>
                                                    {tracking?.updated ? (
                                                        <Text color={'green.500'} fontSize={'14px'} fontWeight={'bold'}>Updated</Text>
                                                    ) : (
                                                        <Text color={'green.500'} fontSize={'14px'} fontWeight={'bold'}>
                                                            {tracking?.status?.charAt(0).toUpperCase() + tracking?.status?.slice(1)}
                                                        </Text>
                                                    )}
                                                    {tracking.status === 'pending' ? <Spinner size="sm" /> : null}
                                                </Box>
                                            </Td>
                                        )}
                                    </Tr>
                                )
                            })}
                        </Tbody>
                    </>
                )}
            </>
        );
    };

    const isBudgetChanged = (() => {
        if (!selectedTracking?.form?.bid_strategy) return false;

        const originalDaily = Number(selectedTracking?.form.daily_budget) / 100;
        const originalLifetime = Number(selectedTracking?.form.lifetime_budget) / 100;

        return (
            (campaignFormik.values.budget === 'daily_budget' && Number(campaignFormik.values.daily_budget) !== originalDaily) ||
            (campaignFormik.values.budget === 'lifetime_budget' && Number(campaignFormik.values.lifetime_budget) !== originalLifetime) ||
            !selectedTracking?.form?.adsets?.length > 0
        );
    })();

    const currentErrors = trackingData && trackingData.some(tracking => tracking?.status === 'error');
    const isPublishDisabled = trackingData && trackingData.some(tracking => tracking?.updated === false);

    useEffect(() => {
        if (trackingData) {
            setPreviousErrors(prev => currentErrors || prev); // Update the flag based on current tracking data
        }
    }, [trackingData]);

    const createAdsetActions = trackingData && trackingData?.filter(item => item.action === 'createAdset');

    const createAdsetAction = createAdsetActions?.find(
        item => item.adset?.adset_id === selectedTracking?.adset?.adset_id
    );

    useEffect(() => {
        if (createAdsetAction) {
            setTargetingData(createAdsetAction?.form?.targeting);
        } else {
            setTargetingData(null);
        }
    }, [createAdsetAction, selectedTracking]);

    return (
        <SidebarWithHeader>
            <Box>
                <Flex mb={'20px'} alignItems={'center'} gap={2}>
                    <Tooltip label="Back" fontSize="xs">
                        <Box>
                            <Icon
                                cursor="pointer"
                                boxSize={6}
                                as={TiArrowBack}
                                onClick={() => {
                                    navigate('/launchpad');
                                }}
                            />
                        </Box>
                    </Tooltip>
                    <Heading as='h1' size='lg'>Publish Status</Heading>
                </Flex>

                {groupedTrackingData && Object.entries(groupedTrackingData).map(([accountName, actions]) => {

                    return (
                        <Box key={accountName} mb={'20px'} p={'20px'} borderWidth={1} borderRadius={'md'}>
                            <Flex justifyContent={'space-between'}>
                                <Heading as='h3' size='md' color={'brand.500'} mb={'10px'}>{accountName}</Heading>
                            </Flex>

                            <Table variant='simple' size={'md'} >
                                <Thead bg={bgColor}>
                                    <Tr>
                                        <Th width={"30%"} px={'5px'} py={'10px'}>Name</Th>
                                        <Th width={"30%"} px={'5px'} py={'10px'}>ID</Th>
                                        <Th width={"40%"} px={'5px'} py={'10px'} textAlign="center">Status</Th>
                                    </Tr>
                                </Thead>
                                <TrackingTable title="Campaign" actions={actions} actionType="createCampaign" />
                                <TrackingTable title="Ad Set" actions={actions} actionType="createAdset" />
                                <TrackingTable title="Ad" actions={actions} actionType="createAd" />
                            </Table>
                        </Box>
                    );
                })}

                {previousErrors && (
                    <Flex justifyContent={'flex-end'} mt={4}>
                        <Button colorScheme="brand"
                            size={'sm'}
                            isLoading={isPublishing}
                            onClick={handleRePublish}
                            isDisabled={isPublishDisabled}
                        >
                            Re-Publish
                        </Button>
                    </Flex>
                )}


                {/* Edit forms */}
                {isEditOpen && (
                    <>
                        {editType === 'createCampaign' && (
                            <Modal
                                size={"xl"}
                                isCentered={true}
                                isOpen={isEditOpen}
                                onClose={() => setIsEditOpen(false)}
                            >
                                <ModalOverlay />
                                <ModalContent>
                                    <ModalHeader>
                                        <Text>Edit Campaign</Text>
                                        {selectedTracking?.error && (
                                            <Flex direction={'column'} gap={1}>
                                                <Text fontWeight="normal" fontSize={'14px'} color='red.500'>{selectedTracking?.error?.error_user_title}</Text>
                                                <Flex alignItems={'center'} gap={'5px'}>
                                                    <InfoOutlineIcon pointerEvents="all" fontSize={'12px'} />
                                                    <Text fontSize={'12px'} fontWeight="normal" >{selectedTracking?.error ? selectedTracking?.error.message : selectedTracking?.error?.error_user_msg ? selectedTracking?.error?.error_user_msg : selectedTracking?.error?.error?.message}</Text>
                                                </Flex>
                                            </Flex>
                                        )}
                                    </ModalHeader>
                                    <ModalCloseButton />
                                    <ModalBody>
                                        <form onSubmit={campaignFormik.handleSubmit}>
                                            <Box width="100%" maxWidth="600px" bg={background} p={4} borderRadius="md">
                                                <Flex direction="column" gap={4}>
                                                    <Box>
                                                        <Flex align="center">
                                                            <Text mb={2}>
                                                                Campaign Name
                                                            </Text>
                                                        </Flex>
                                                        <Input
                                                            placeholder="Enter campaign name"
                                                            bg="#fff"
                                                            name="name"
                                                            size={'sm'}
                                                            borderRadius="md"
                                                            value={campaignFormik.values.name}
                                                            onChange={campaignFormik.handleChange}
                                                            onBlur={campaignFormik.handleBlur}
                                                        />
                                                        {campaignFormik.touched.name && campaignFormik.errors.name && (
                                                            <Text fontSize={'12px'} color="red.500" mt={1}>{campaignFormik.errors.name}</Text>
                                                        )}
                                                    </Box>

                                                    <Box>
                                                        <Flex align="center">
                                                            <Text mb={2}>
                                                                Objective
                                                            </Text>
                                                        </Flex>
                                                        <Select
                                                            name="type"
                                                            borderRadius="md"
                                                            value={campaignFormik.values.objective}
                                                            onChange={campaignFormik.handleChange}
                                                            onBlur={campaignFormik.handleBlur}
                                                            size="sm"
                                                            isDisabled
                                                        >
                                                            <option value="OUTCOME_LEAD">Leads</option>
                                                            <option value="OUTCOME_SALES">Sales</option>
                                                            <option value="OUTCOME_AWARENESS">Awareness</option>
                                                            <option value="OUTCOME_TRAFFIC">Traffic</option>
                                                            <option value="OUTCOME_ENGAGEMENT">Engagement</option>
                                                            <option value="OUTCOME_APP_PROMOTION">App promotion</option>
                                                        </Select>
                                                    </Box>

                                                    {/* Advantage campaign section */}
                                                    {/* <Box>
                                                        <Flex alignItems={'center'} justifyContent={'space-between'} mb={2}>
                                                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                                                <Text fontWeight="bold">Advantage campaign budget</Text>
                                                                <GiStarShuriken />
                                                            </Box>

                                                            <Box display={'flex'} alignItems={'center'} gap={2}>
                                                                <Text>{campaignFormik.values.isAdvantageCampaignEnabled ? 'On' : 'Off'}</Text>

                                                                <Tooltip
                                                                    borderRadius={5}
                                                                    placement="right"
                                                                    isDisabled={!!(selectedTracking?. form?.adsets?.length > 0)} 
                                                                    label={
                                                                    <Box fontSize="sm" p="5px">
                                                                        <Text>
                                                                            To turn off Advantage campaign budget, you must create an ad set in this campaign.
                                                                        </Text>
                                                                    </Box>
                                                                    }
                                                                    fontSize="md"
                                                                    hasArrow
                                                                >
                                                                    <Box display="inline-block"> 
                                                                        <Switch
                                                                            colorScheme="brand"
                                                                            isDisabled={!selectedTracking?. form?.adsets?.length}
                                                                            isChecked={campaignFormik.values.isAdvantageCampaignEnabled}
                                                                            onChange={() =>
                                                                            campaignFormik.setFieldValue(
                                                                                'isAdvantageCampaignEnabled',
                                                                                !campaignFormik.values.isAdvantageCampaignEnabled
                                                                            )
                                                                            }
                                                                        />
                                                                    </Box>
                                                                </Tooltip>
                                                            </Box>
                                                        </Flex>
                                                        <Text fontSize={'12px'} textAlign={'justify'}>Distribute your budget across ad sets to get more results. You can control spending for each ad set.</Text>
                                                    </Box> */}

                                                    {/* {campaignFormik.values.isAdvantageCampaignEnabled ? (
                                                        <>
                                                            <Flex my={2} direction={'column'} gap={2}>
                                                                    <Flex alignItems={'center'}>
                                                                        <Text fontWeight="bold">Budget</Text>
                                                                        <Tooltip
                                                                            borderRadius={5}
                                                                            label={
                                                                                <Box fontSize="sm" p={'5px'}>
                                                                                    <Text >
                                                                                        If you choose a daily budget, you may spend more on some days and less on others but will maintain an average daily budget. If you choose a lifetime budget, we'll never spend more than that amount.
                                                                                    </Text>
                                                                                </Box>
                                                                            }
                                                                            fontSize="md"
                                                                        >
                                                                            <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                                        </Tooltip>
                                                                    </Flex>
                                                                    <Flex gap={1}>
                                                                        <Select
                                                                            name="budget"
                                                                            value={campaignFormik.values.budget}
                                                                            onChange={handleBudgetChange}
                                                                            onBlur={campaignFormik.handleBlur}
                                                                            bg="#fff"
                                                                            borderRadius={'md'}
                                                                            maxW={'200px'}
                                                                            size={'sm'}
                                                                            isDisabled = {selectedTracking?. form?.bid_strategy}
                                                                        >
                                                                            {budgetOptions?.map((option) => (
                                                                                <option key={option.value} value={option.value}>
                                                                                    {option.label}
                                                                                </option>
                                                                            ))}
                                                                        </Select>
                                                                        {campaignFormik.values.budget  === 'daily_budget' ? (
                                                                            <InputGroup>
                                                                                <Input
                                                                                    name="daily_budget"
                                                                                    placeholder={currencySymbol}
                                                                                    bg="#fff"
                                                                                    type="number"
                                                                                    value={String(campaignFormik.values.daily_budget)}
                                                                                    onChange={(e) => campaignFormik.setFieldValue('daily_budget', e.target.value)}
                                                                                    onBlur={campaignFormik.handleBlur}
                                                                                    borderRadius={'md'}
                                                                                    size={'sm'}
                                                                                />
                                                                                <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                                                    {currencyCode}
                                                                                </InputRightAddon>
                                                                            </InputGroup>
                                                                        ): null}
                                                                        {campaignFormik.values.budget  === 'lifetime_budget' ? (
                                                                            <InputGroup>
                                                                                <Input
                                                                                    name="lifetime_budget"
                                                                                    placeholder={currencySymbol}
                                                                                    bg="#fff"
                                                                                    type="number"
                                                                                    value={String(campaignFormik.values.lifetime_budget)}
                                                                                    onChange={(e) => campaignFormik.setFieldValue('lifetime_budget', e.target.value)}
                                                                                    onBlur={campaignFormik.handleBlur}
                                                                                    borderRadius={'md'}
                                                                                    size={'sm'}
                                                                                />
                                                                                <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                                                    {currencyCode}
                                                                                </InputRightAddon>
                                                                            </InputGroup>
                                                                        ):null}
                                                                    </Flex>
                                                                    <Box display={'flex'} flexDirection='column' gap='2'>
                                                                        <Flex alignItems={'center'}>
                                                                            <Text fontWeight="bold">Campaign bid strategy</Text>
                                                                            <Tooltip
                                                                                borderRadius={5}
                                                                                label={
                                                                                    <Box fontSize="sm" p={'5px'}>
                                                                                        <Text >
                                                                                            Cost per result goal, ROAS goal or bid caps allow you to enter a specific amount later for each ad set.
                                                                                        </Text>
                                                                                    </Box>
                                                                                }
                                                                                fontSize="md"
                                                                            >
                                                                                <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                                            </Tooltip>
                                                                        </Flex>

                                                                        <Flex>
                                                                            <Text fontSize={'12px'}>How we'll bid in ad auctions.</Text>
                                                                        </Flex>

                                                                        <Flex>
                                                                            <Menu>
                                                                                <MenuButton
                                                                                    as={Button}
                                                                                    border="1px solid #CBD5E0"
                                                                                    borderRadius="md"
                                                                                    p={2}
                                                                                    bg={isBudgetChanged ? 'gray.50' : '#fff'}
                                                                                    cursor={isBudgetChanged ? "not-allowed" : "pointer"}
                                                                                    _hover={{ bg: isBudgetChanged ? 'gray.50' : '#fff' }}
                                                                                    w='auto'
                                                                                    fontSize='12px'
                                                                                >
                                                                                    <Flex alignItems={'center'} justifyContent="space-between" gap='2'>
                                                                                        <Text color={isBudgetChanged ? 'gray.500' : 'none'}>
                                                                                        {campaignFormik.values.bid_strategy 
                                                                                            ? (campaignFormik.values.objective === 'OUTCOME_SALES'
                                                                                                ? bidStrategiesForSales.find(option => option.value === campaignFormik.values.bid_strategy)?.label 
                                                                                                : campaignFormik.values.objective === 'OUTCOME_LEADS'
                                                                                                ? bidStrategiesForLeads.find(option => option.value === campaignFormik.values.bid_strategy)?.label
                                                                                                : "Select a bid strategy")
                                                                                            : "Select a bid strategy"}
                                                                                        </Text>
                                                                                        <ChevronDownIcon boxSize='5'/>
                                                                                    </Flex>
                                                                                </MenuButton>

                                                                                {isBudgetChanged ? null : (
                                                                                    <MenuList zIndex={20}>
                                                                                        {(campaignFormik.values.objective === 'OUTCOME_SALES' ? bidStrategiesForSales : bidStrategiesForLeads).map((option) => {
                                                                                        const isBidCap = option.value === 'LOWEST_COST_WITH_BID_CAP';

                                                                                        const MenuItemContent = (
                                                                                            <Box
                                                                                                display="flex"
                                                                                                justifyContent="space-between"
                                                                                                width="100%"
                                                                                                alignItems="center"
                                                                                                py={2}
                                                                                                px={2}
                                                                                            >
                                                                                            <Box>
                                                                                                <Text fontWeight="medium" fontSize="12px">{option.label}</Text>
                                                                                                <Text fontSize="12px">{option.description}</Text>
                                                                                            </Box>
                                                                                            {isBidCap && selectedTracking?. form?.bid_strategy !== 'LOWEST_COST_WITH_BID_CAP' && (
                                                                                                <Text fontSize="lg" ml={2}>{'>'}</Text>
                                                                                            )}
                                                                                            </Box>
                                                                                        );

                                                                                        return (isBidCap && selectedTracking?. form?.bid_strategy !== 'LOWEST_COST_WITH_BID_CAP') ? (
                                                                                            <Popover trigger="hover" placement="right-start" closeOnBlur={false} key={option.value}>
                                                                                            <PopoverTrigger>
                                                                                                <Box width="100%">
                                                                                                <MenuItem
                                                                                                    _hover={{ bg: 'gray.50' }}
                                                                                                    p={0}
                                                                                                >
                                                                                                    {MenuItemContent}
                                                                                                </MenuItem>
                                                                                                </Box>
                                                                                            </PopoverTrigger>
                                                                                            <PopoverContent
                                                                                                cursor='pointer'
                                                                                                width="auto"
                                                                                                onMouseEnter={(e) => e.stopPropagation()}
                                                                                                onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                    campaignFormik.setFieldValue('bid_strategy', option.value);
                                                                                                    onBidModalOpen();
                                                                                                }}
                                                                                            >
                                                                                                <PopoverArrow />
                                                                                                <PopoverBody>
                                                                                                    <Text fontWeight="semibold" fontSize='14px'>Bid cap</Text>
                                                                                                    <Text fontSize="12px">
                                                                                                        Set the highest that you want to bid in any auction.
                                                                                                    </Text>
                                                                                                </PopoverBody>
                                                                                            </PopoverContent>
                                                                                            </Popover>
                                                                                        ) : (
                                                                                            <MenuItem
                                                                                                key={option.value}
                                                                                                onClick={() => {
                                                                                                    campaignFormik.setFieldValue('bid_strategy', option.value);
                                                                                                    if (
                                                                                                        selectedTracking?. form?.bid_strategy === 'LOWEST_COST_WITHOUT_CAP' && 
                                                                                                        option.value === 'LOWEST_COST_WITHOUT_CAP'
                                                                                                    ) {
                                                                                                    return;
                                                                                                    }else if (selectedTracking?. form?.bid_strategy !== option.value && option.value !== 'LOWEST_COST_WITHOUT_CAP'){
                                                                                                        onBidModalOpen();
                                                                                                    }
                                                                                                }}
                                                                                                _hover={{ bg: 'gray.50' }}
                                                                                                py={2}
                                                                                                flexDirection="column"
                                                                                                alignItems="flex-start"
                                                                                            >
                                                                                            <Text fontWeight="medium" fontSize="12px">{option.label}</Text>
                                                                                            <Text fontSize="12px">{option.description}</Text>
                                                                                            </MenuItem>
                                                                                        );
                                                                                        })}
                                                                                    </MenuList>
                                                                                )}
                                                                            </Menu>
                                                                        </Flex>

                                                                        <Flex alignItems={'center'}>
                                                                            <Text fontSize={'10px'}>Not all bid strategies are available for all campaigns.</Text>
                                                                            <Tooltip
                                                                                borderRadius={5}
                                                                                label={
                                                                                    <Box fontSize="12px" p={'5px'}>
                                                                                        <Text >
                                                                                            The highest-volume bid strategy is only available if all ad sets are using the same delivery optimisation.<br></br>
                                                                                            Cost per result goal is only available for some delivery optimisations.
                                                                                        </Text>
                                                                                    </Box>
                                                                                }
                                                                                fontSize="md"
                                                                            >
                                                                                <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                                            </Tooltip>
                                                                        </Flex>
                                                                    </Box>
                                                            </Flex>

                                                            <Divider />

                                                            <Flex direction='column' gap={1}>
                                                                <Flex alignItems={'center'}>
                                                                    <Text fontWeight="bold">Ad scheduling</Text>
                                                                    <Tooltip
                                                                        borderRadius={5}
                                                                        label={
                                                                            <Box fontSize="sm" p={'5px'}>
                                                                                <Text >
                                                                                    You can schedule your ads to deliver on specific hours and days of the week based on the viewer's or your ad account's time zone.
                                                                                </Text>
                                                                            </Box>
                                                                        }
                                                                        fontSize="md"
                                                                    >
                                                                        <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                                    </Tooltip>
                                                                </Flex>
                                                                <Text fontSize='12px'>You'll set the specific schedule within each ad set.</Text>
                                                                <Flex>
                                                                    <Checkbox
                                                                        size={'md'}
                                                                        colorScheme='brand'
                                                                        isChecked={campaignFormik.values.isAdScheduled}
                                                                        onChange={() => campaignFormik.setFieldValue('isAdScheduled', !campaignFormik.values.isAdScheduled)}
                                                                        isDisabled={campaignFormik.values.budget !== 'lifetime_budget'}
                                                                    >
                                                                        <Flex direction='column'>
                                                                            <Text fontSize='12px'>Run ads on a schedule</Text>
                                                                            {campaignFormik.values.budget !== 'lifetime_budget' ? 
                                                                                <Text fontSize='10px'>Ad scheduling is only available when you use lifetime budget.</Text>
                                                                            :null}
                                                                        </Flex>
                                                                    </Checkbox>
                                                                </Flex>
                                                            </Flex>
                                                        </>
                                                    ) : (null)} */}

                                                </Flex>
                                            </Box>

                                            {/* Submit Button in a separate Flex container */}
                                            <Flex mt={4}>
                                                <Button
                                                    colorScheme="brand"
                                                    isLoading={isCampaignUpdating}
                                                    isDisabled={!campaignFormik.isValid}
                                                    type="submit"
                                                    size={'sm'}
                                                    mb={'10px'}
                                                >
                                                    Save
                                                </Button>
                                            </Flex>
                                        </form>
                                    </ModalBody>
                                </ModalContent>
                            </Modal>
                        )}
                        {editType === 'createAdset' && (
                            <Modal
                                size={"5xl"}
                                isCentered={true}
                                isOpen={isEditOpen}
                                scrollBehavior={"inside"}
                                onClose={() => setIsEditOpen(false)}
                            >
                                <ModalOverlay />
                                <ModalContent>
                                    <ModalHeader>
                                        <Text >Edit Ad Set</Text>
                                        {selectedTracking?.error && (
                                            <Flex direction={'column'} gap={1}>
                                                <Text fontWeight="normal" fontSize={'14px'} color='red.500'>{selectedTracking?.error?.error_user_title}</Text>
                                                <Flex alignItems={'center'} gap={'5px'}>
                                                    <InfoOutlineIcon pointerEvents="all" fontSize={'12px'} />
                                                    <Text fontSize="12px" fontWeight="normal">
                                                        {selectedTracking?.error?.error_user_msg ||
                                                            selectedTracking?.error?.message ||
                                                            selectedTracking?.error?.error?.message ||
                                                            selectedTracking?.error?.message ||
                                                            ''}
                                                    </Text>
                                                </Flex>
                                            </Flex>
                                        )}
                                    </ModalHeader>
                                    <ModalCloseButton />
                                    <ModalBody>
                                        {campaignType === 'OUTCOME_SALES' && (isLoadingSales || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_SALES' && dataSales && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && !productCatalogId && (
                                                <SalesForm
                                                    data={dataSales.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    isEditing={"isEditing"}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    onClose={() => setIsEditOpen(false)}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                    context={'trackEdit'}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_SALES' && (isLoadingCatalogueSales || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_SALES' && dataCatalogueSales && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && productCatalogId &&  (
                                                <CatalogueSalesForm
                                                    data={dataCatalogueSales.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    isEditing={"isEditing"}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    onClose={() => setIsEditOpen(false)}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                    context={'trackEdit'}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_LEADS' && (isLoadingLeads || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_LEADS' && dataLeads && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && (
                                                <LeadsForm
                                                    data={dataLeads.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    onClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                    context={'trackEdit'}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_SALES' && (isLoadingAdvantageShopping || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_SALES' && dataAdvantageShopping && selectedTracking && bmAdAccountsDetails?.data && smartPromotionType && (
                                                <AdvantagePlusShoppingSalesForm
                                                    data={dataAdvantageShopping?.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    onClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    context={'trackEdit'}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_APP_PROMOTION' && (isLoadingAppPromotions || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_APP_PROMOTION' && dataAppPromotions && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && (
                                                <AppPromotionForm
                                                    data={dataAppPromotions?.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    onClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    context={'trackEdit'}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_AWARENESS' && (isLoadingAwareness || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_AWARENESS' && dataAwareness && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && (
                                                <AwarenessForm
                                                    data={dataAwareness?.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    onClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    context={'trackEdit'}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_TRAFFIC' && (isLoadingTraffic || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_TRAFFIC' && dataTraffic && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && (
                                                <TrafficForm
                                                    data={dataTraffic?.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    onClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    context={'trackEdit'}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                />
                                            )
                                        )}

                                        {campaignType === 'OUTCOME_ENGAGEMENT' && (isLoadingEngagement || isBmAdAccountsLoading) ? (
                                            <Flex justifyContent={'center'} alignItems={'center'} h={'60vh'}>
                                                <Spinner size={'md'} />
                                            </Flex>
                                        ) : (
                                            campaignType === 'OUTCOME_ENGAGEMENT' && dataEngagement && selectedTracking && bmAdAccountsDetails?.data && !smartPromotionType && (
                                                <EngagementForm
                                                    data={dataEngagement?.data}
                                                    adsetsListData={selectedTracking}
                                                    campaignData={createCampaignTracking}
                                                    onClose={() => setIsEditOpen(false)}
                                                    isEditing={"isEditing"}
                                                    context={'trackEdit'}
                                                    selectedAdset={selectedTracking?.adset?.id}
                                                    selectedAdAccounts={bmAdAccountsDetails?.data}
                                                    onEditModalClose={() => setIsEditOpen(false)}
                                                    onSaveSuccess={handleSaveSuccess}
                                                />
                                            )
                                        )}
                                    </ModalBody>
                                </ModalContent>
                            </Modal>
                        )}
                        {editType === 'createAd' && (
                            <Modal
                                size={"6xl"}
                                isCentered={true}
                                isOpen={isEditOpen}
                                onClose={() => setIsEditOpen(false)}
                                scrollBehavior={"inside"}
                            >
                                <ModalOverlay />
                                <ModalContent>
                                    <ModalHeader>
                                        <Text >Edit Ad</Text>
                                        {selectedTracking?.error && (
                                            <Flex direction={'column'} gap={1}>
                                                <Text fontWeight="normal" fontSize={'14px'} color='red.500'>{selectedTracking?.error?.error_user_title ? selectedTracking?.error?.error_user_title : selectedTracking?.error?.error?.error_user_title}</Text>
                                                <Flex alignItems={'center'} gap={'5px'}>
                                                    <InfoOutlineIcon pointerEvents="all" fontSize={'12px'} />
                                                    <Text fontSize={'12px'} fontWeight="normal" >{selectedTracking?.error?.error_user_msg ? selectedTracking?.error?.error_user_msg : selectedTracking?.error?.error?.error_user_msg}</Text>
                                                </Flex>
                                            </Flex>
                                        )}
                                    </ModalHeader>
                                    <ModalCloseButton />
                                    <ModalBody>
                                    {(() => {
                                        const creatives = selectedTracking?.form?.adcreative;
                                        const isArrayCreatives = Array.isArray(creatives);
                                        const hasProductsInArray = isArrayCreatives && creatives.some(item => !!item.product_set_id);
                                        const hasSingleAssetFormats = selectedTracking?.form?.adcreative?.asset_feed_spec?.ad_formats?.length > 0;
                                        const hasProductSetSingle = selectedTracking?.form?.adcreative?.product_set_id 

                                        if (targetingData) {
                                        if (hasProductsInArray) {
                                            return (
                                            <CatalogueCarouselPublishAdUpdate
                                                trackingData={selectedTracking}
                                                onClose={() => setIsEditOpen(false)}
                                                onSaveSuccess={handleSaveSuccess}
                                                targeting={targetingData}
                                            />
                                            );
                                        }

                                        if (isArrayCreatives && creatives.length > 0) {
                                            return (
                                            <CarouselPublishAdupdate
                                                trackingData={selectedTracking}
                                                onClose={() => setIsEditOpen(false)}
                                                onSaveSuccess={handleSaveSuccess}
                                                targeting={targetingData}
                                            />
                                            );
                                        }

                                        if (hasSingleAssetFormats) {
                                            return (
                                            <SizePublishAdupdate
                                                trackingData={selectedTracking}
                                                onClose={() => setIsEditOpen(false)}
                                                onSaveSuccess={handleSaveSuccess}
                                                targeting={targetingData}
                                            />
                                            );
                                        }

                                        if (hasProductSetSingle) {
                                            return (
                                            <CatalogueSinglePublishAdUpdate
                                                trackingData={selectedTracking}
                                                onClose={() => setIsEditOpen(false)}
                                                onSaveSuccess={handleSaveSuccess}
                                                targeting={targetingData}
                                            />
                                            );
                                        }
                                        }

                                        if (!hasProductSetSingle) {
                                            return (
                                            <SinglePublishAdupdate
                                                trackingData={selectedTracking}
                                                onClose={() => setIsEditOpen(false)}
                                                onSaveSuccess={handleSaveSuccess}
                                                targeting={targetingData}
                                            />
                                            );
                                        }

                                    })()}
                                    </ModalBody>
                                </ModalContent>
                            </Modal>
                        )}
                    </>
                )}
            </Box>

            <Modal isOpen={isBidModalOpen} onClose={onBidModalClose} scrollBehavior="inside" isCentered size="2xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader p={2} fontSize="md">Set bid caps for 3 ad sets</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody borderTop="1px" borderColor="gray.100">
                        <Text fontSize="12px" mb={4}>
                            Set bid caps for all of the ad sets (published and inactive) in this campaign.
                        </Text>

                        <Box border="1px" borderColor="gray.200" borderRadius="md" overflow="hidden">
                            <Table size="sm" variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th fontSize="12px">Ad set name</Th>
                                        <Th fontSize="12px">{campaignFormik.values.bid_strategy === 'LOWEST_COST_WITH_BID_CAP' ? 'Bid cap' : campaignFormik.values.bid_strategy === 'COST_CAP' ? 'Cost per result goal' : 'ROAS goal'}</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {selectedTracking?.form?.adset?.map((adSet, _id) => (
                                        <Tr key={_id}>
                                            <Td fontSize="12px" borderRight={'2px'} borderRightColor={'green.500'}>{adSet.name}</Td>
                                            <Td fontSize="12px">
                                                <Input
                                                    placeholder={currencySymbol}
                                                    size="sm"
                                                    width="80px"
                                                    value={adsetBidAmounts[adSet?._id]}
                                                    type="number"
                                                    onChange={(e) => {
                                                        const newValue = parseFloat(e.target.value);
                                                        setAdsetBidAmounts(prev => ({
                                                            ...prev,
                                                            [adSet._id]: newValue,
                                                        }));
                                                    }}
                                                />
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>

                        <Box pt={8}>
                            <Flex gap={4}>
                                <Flex>
                                    <Text fontWeight="bold">Campaign budget</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text>
                                                    {selectedTracking?.form?.daily_budget ? 'With a daily budget, we may spend more on some days and less on others, but will maintain an average daily budget.' : 'With a lifetime budget, we may spend more on some days and less on others, but will maintain an average lifetime budget.'}
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" m={1} />
                                    </Tooltip>
                                </Flex>
                                <Flex w={'120px'} direction='column' gap={1}>
                                    {campaignFormik.values.budget === 'daily_budget' ? (
                                        <InputGroup>
                                            <Input
                                                name="daily_budget"
                                                placeholder={currencySymbol}
                                                bg="#fff"
                                                type="number"
                                                value={String(campaignFormik.values.daily_budget)}
                                                onChange={(e) => campaignFormik.setFieldValue('daily_budget', e.target.value)}
                                                onBlur={campaignFormik.handleBlur}
                                                borderRight={'none'}
                                                size={'sm'}
                                            />
                                            <InputRightAddon height={'32px'} fontSize={'10px'} bg='none' borderRadius={'none'}>
                                                {currencyCode}
                                            </InputRightAddon>
                                        </InputGroup>
                                    ) : null}
                                    {campaignFormik.values.budget === 'lifetime_budget' ? (
                                        <InputGroup>
                                            <Input
                                                name="lifetime_budget"
                                                placeholder={currencySymbol}
                                                bg="#fff"
                                                type="number"
                                                value={String(campaignFormik.values.lifetime_budget)}
                                                onChange={(e) => campaignFormik.setFieldValue('lifetime_budget', e.target.value)}
                                                onBlur={campaignFormik.handleBlur}
                                                borderRadius={'md'}
                                                size={'sm'}
                                            />
                                            <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                {currencyCode}
                                            </InputRightAddon>
                                        </InputGroup>
                                    ) : null}
                                    <Flex>
                                        <Text fontSize={'12px'} color='gray' fontWeight='semibold'>{campaignFormik.values.budget === 'daily_budget' ? 'daily budget' : 'lifetime budget'}</Text>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Box>
                    </ModalBody>

                    <ModalFooter>
                        <Flex borderTop="1px" borderColor="gray.100" pt={2} justifyContent="space-between" w="100%">
                            <Button onClick={onBidModalClose} size="sm">
                                Close
                            </Button>
                            <Button
                                onClick={() => {
                                    campaignFormik.handleSubmit();
                                    onBidModalClose();
                                    setIsEditOpen(false);
                                }}
                                size="sm"
                                colorScheme="brand"
                            >
                                Save
                            </Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </SidebarWithHeader>
    );
};